import { RefObject, useEffect, useRef, useState } from 'react';

export const useIsOutOfTop: (
  isBeforeSetRef?: boolean,
  threshold?: number,
) => [RefObject<HTMLDivElement>, boolean] = (
  isBeforeSetRef?: boolean,
  threshold?: number,
) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOutOfTop, setIsOutOfTop] = useState(false);

  useEffect(() => {
    const refMemo = ref.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          setIsOutOfTop(entry.intersectionRatio < (threshold ?? 1));
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: threshold ?? 1,
      },
    );
    if (!isBeforeSetRef && refMemo) {
      observer.observe(refMemo);
    }
    return () => {
      if (!isBeforeSetRef && refMemo) {
        observer.unobserve(refMemo);
      }
    };
  }, [isBeforeSetRef, setIsOutOfTop]);

  return [ref, isOutOfTop];
};

export default useIsOutOfTop;
